import { ResultFormat } from "components/Button/ResultFormatButton";
import { SearchResultLoading } from "./SearchResultLoading";

export const LOADING_RESULTS_COUNT = 8;

type SearchResultsListProps = {
  resultFormat?: ResultFormat;
};

const SearchResultsListLoading = ({
  resultFormat = ResultFormat.COMPACT,
}: SearchResultsListProps) => {
  return (
    <div className="w-full">
      {Array.from({
        length: LOADING_RESULTS_COUNT,
      }).map((_, index) => (
        <SearchResultLoading
          key={index}
          index={index}
          resultFormat={resultFormat}
        />
      ))}
    </div>
  );
};

export default SearchResultsListLoading;
